import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Ye page ab Home ke "Find Poojari" tab mein aa gaya hai
// Purane links/bookmarks ke liye redirect
const SearchPoojari = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/home', {
            state: { tab: 'find' },
            replace: true
        });
    }, []);

    return null;
};

export default SearchPoojari;